import { accessControlApi } from "./access-controlApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Role } from "./roles/roles.interface";
import { Permissions } from "./permissions/permissions.interface";
import { RootState } from "@/app/store";
import { APIError, APIResponse } from "@/types/custom-http";
import { SettingsAccessControl } from "./access-control.interface";


export const fetchRoles = createAsyncThunk<
  APIResponse<Role[]>,
  void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'accessControl/fetchRoles',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        accessControlApi.endpoints.getRoles.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
        return rejectWithValue({
          status,
          message: data?.message || 'Error al obtener Roles de Usuarios',
          details: data.details
        });
    }
  }
);


export const fetchPermissions = createAsyncThunk<APIResponse<Permissions[]>, void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'accessControl/fetchPermissions',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        accessControlApi.endpoints.getPermissions.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Permisos de Usuarios',
        details: data.details
      });
    }
  }
);


export const fetchPermissionsRoles = createAsyncThunk<APIResponse<SettingsAccessControl>, void,
  {
    state: RootState;
    rejectValue: { status: number; message: string; details?: Record<string, string[]> };
  }
>(
  'accessControl/fetchPermissionsRoles',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        accessControlApi.endpoints.getPermissionsRoles.initiate()
      ).unwrap();
      return result;
    } catch (error) {
      const apiError = error as APIError;
      const { status, data } = apiError;
      return rejectWithValue({
        status,
        message: data?.message || 'Error al obtener Permisos de los Roles de Usuarios',
        details: data.details
      });
    }
  }
);